import * as moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Modal,
  ModalBody,
  UncontrolledDropdown,
} from "reactstrap";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  Col,
  Icon,
  Row,
  RSelect
} from "../../components/Component";
import Table from "../../components/react-table/Table";
import { useUser } from "../../context/user";
import { DELETE, GET, POST, PUT } from "../../helper/api";
import Content from "../../layout/content/Content";
import Head from "../../layout/head/Head";
import { EMPLOYEE_UNIT, USER_ACTIVE_TYPE, USER_ROLES, USER_ROLES_NAME } from "../../utils/Utils";


const USER_ROLES_OPTIONS = Object.keys(USER_ROLES).map((c) => ({
  label: USER_ROLES_NAME[c],
  value: c,
}));

const USER_ACTIVE_TYPE_OPTIONS = Object.keys(USER_ACTIVE_TYPE).map((c) => ({
  label: USER_ACTIVE_TYPE[c],
  value: c,
}));


const UserManager = () => {
  const history = useHistory();
  const clearPagi = useRef();
  const [data, setData] = useState([]);
  const [view, setView] = useState({
    isDelete: false,
    changePass: false,
    increaseAnnualSalary: false
  });


  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const [loading, setLoading] = useState(false);
  const [editId, setEditedId] = useState();
  const [deleteId, setDeleteId] = useState();
  const [timeNow, setTimeNow] = useState();
  const [smOption, setSmOption] = useState(false);
  const [newPassword, setNewPassword] = useState("");
  const [filter, setFilter] = useState({
    active: searchParams.get("active") || 'true',
    role: searchParams.get("role") || '',
  });
  const {
    state: { user },
  } = useUser();

  const colTable = [

    {
      Header: "Tài khoản",
      accessor: "username",
    },
    {
      Header: "Tên",
      accessor: "name",
    },
    {
      Header: "Vai trò",
      accessor: (item) => USER_ROLES_NAME[item.role]
    },
    {
      Header: "Khối",
      accessor: (item) => EMPLOYEE_UNIT[item.unit]
    },
    {
      Header: "Trạng thái",
      accessor: (item) => USER_ACTIVE_TYPE[!!item.active],
    },
    ...(user && ["ADMIN", 'MANAGER', 'ENTRY_STAFF'].includes(user.role)
      ? [
        {
          Header: "Hành động",
          accessor: (item) => (
            item.role !== 'ADMIN'
              ?
              <ul className="nk-tb-actions gx-1">
                <li>
                  <UncontrolledDropdown>
                    <DropdownToggle
                      tag="a"
                      className="btn btn-icon dropdown-toggle btn-trigger"
                    >
                      <Icon name="more-h"></Icon>
                    </DropdownToggle>
                    <DropdownMenu right>
                      <ul className="link-list-opt no-bdr">

                        <li>
                          <DropdownItem
                            tag="a"
                            href="#edit"
                            onClick={(ev) => {
                              history.push(`/user/${item.id}`)
                              ev.preventDefault();
                            }}
                          >
                            <Icon name="edit"></Icon>
                            <span>Cập nhật</span>
                          </DropdownItem>
                        </li>
                        <li>
                          <DropdownItem
                            tag="a"
                            href="#edit"
                            onClick={(ev) => {
                              history.push(`/user/create?duplicateId=${item.id}`)
                              ev.preventDefault();
                            }}
                          >
                            <Icon name="copy"></Icon>
                            <span>Nhân bản</span>
                          </DropdownItem>
                        </li>


                        <li>
                          <DropdownItem
                            tag="a"
                            href="#changePass"
                            onClick={(ev) => {
                              ev.preventDefault();
                              onChangePassClick(item.id);
                              toggle("changePass");
                            }}
                          >
                            <Icon name="lock"></Icon>
                            <span>Đổi mật khẩu</span>
                          </DropdownItem>
                        </li>
                        <li>
                          <DropdownItem
                            tag="a"
                            href="#dropdown"
                            onClick={(ev) => {
                              ev.preventDefault();
                              setDeleteId(item.id);
                              toggle("isDelete");
                            }}
                          >
                            <Icon name="trash" className="text-danger"></Icon>
                            <span>Xoá</span>
                          </DropdownItem>
                        </li>
                      </ul>
                    </DropdownMenu>
                  </UncontrolledDropdown>
                </li>
              </ul>
              : ''
          ),
        },
      ]
      : []),
  ];

  // Changing state value when searching name
  useEffect(() => {
    const newParams = new URLSearchParams({
      ...(filter.active ? { active: filter.active } : {}),
      ...(filter.role ? { role: filter.role } : {}),
    });
    history.replace({
      pathname: location.pathname,
      search: newParams.toString(),
    });


    setLoading(true);
    setData([]);
    let params = {
      ...(filter.active ? { active: filter.active } : {}),
      ...(filter.role ? { role: filter.role } : {}),
    };

    GET(`user`, params, true)
      .then(({ data }) => {
        setData([...data]);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [timeNow, filter]);

  // toggle function to view order details
  const toggle = (type) => {
    setView({
      ...view,
      [type]: !view[type],
    });
  };

  const resetData = () => {
    onFormCancel();
    setTimeNow(moment().valueOf());
  };


  const onSubmitChangPassword = () => {
    if (!newPassword) return toast.error("Vui lòng nhập mật khẩu");
    setLoading(true);
    PUT(`/user/change-password/${editId}`, { newPassword }, {}, true)
      .then(() => {
        toast.success("Thay đổi mật khẩu thành công");
        resetData();
      })
      .catch(({ response }) => {
        toast.error(
          response?.data?.error || "Có lỗi xảy ra! Vui lòng thử lại."
        );
      })
      .finally(() => setLoading(false));
  };

  // function to close the form modal
  const onFormCancel = () => {
    setView({ isDelete: false, changePass: false, increaseAnnualSalary: false });
    setEditedId(null);
    setDeleteId(null);
  };

  const deleteUser = (id) => {
    if (!id) {
      return;
    }
    DELETE(`user/${id}`, {}, true)
      .then((res) => {
        toast.success("Xóa người dùng thành công");
        resetData();
      })
      .catch(({ response }) => {
        toast.error(
          response?.data?.error || "Có lỗi xảy ra! Vui lòng thử lại."
        );
      });
  };


  const increaseAnnualSalary = () => {
    POST(`user/increase-annual-salary`, {}, {}, true)
      .then((res) => {
        toast.success("Cập nhật thành công");
        resetData();
      })
      .catch(({ response }) => {
        toast.error(
          response?.data?.error || "Có lỗi xảy ra! Vui lòng thử lại."
        );
      });
  };

  const onChangePassClick = (id) => {
    setEditedId(id);
  };

  return (
    <React.Fragment>
      <Head title="Quản lý người dùng"></Head>
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page>Người dùng</BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="toggle-wrap nk-block-tools-toggle">
                <a
                  href="#more"
                  className="btn btn-icon btn-trigger toggle-expand mr-n1"
                  onClick={(ev) => {
                    ev.preventDefault();
                    setSmOption(!smOption);
                  }}
                >
                  <Icon name="more-v"></Icon>
                </a>
                <div
                  className="toggle-expand-content"
                  style={{ display: smOption ? "block" : "none" }}
                >
                  <ul className="d-lg-flex g-3 pt-1 pb-1 custom-filter-header justify-content-end">
                    <li>
                      <div
                        className="form-control-wrap"
                        style={{ width: "200px" }}
                      >
                        <RSelect
                          isClearable
                          placeholder="Chọn trạng thái"
                          classNamePrefix="form-control"
                          options={USER_ACTIVE_TYPE_OPTIONS}
                          value={USER_ACTIVE_TYPE_OPTIONS.find(
                            (c) => c.value === filter.active
                          )}
                          onChange={(val) =>
                            setFilter({
                              ...filter,
                              active: (val && val.value) || "",
                            })
                          }
                        />
                      </div>
                    </li>

                    <li>
                      <div
                        className="form-control-wrap"
                        style={{ width: "200px" }}
                      >
                        <RSelect
                          isClearable
                          placeholder="Chọn vai trò"
                          classNamePrefix="form-control"
                          options={USER_ROLES_OPTIONS}
                          value={USER_ROLES_OPTIONS.find(
                            (c) => c.value === filter.role
                          )}
                          onChange={(val) =>
                            setFilter({
                              ...filter,
                              role: (val && val.value) || "",
                            })
                          }
                        />
                      </div>
                    </li>
                    <li>
                      <div>
                        <Button
                          className="btn-primary"
                          color="primary"
                          onClick={() => {
                            history.push(`/user/create`)
                          }}
                        >
                          <Icon name="plus"></Icon>
                          <span>Thêm người dùng</span>
                        </Button>
                      </div>
                    </li>
                    <li>
                      <div>
                        <Button
                          className="btn-primary"
                          color="primary"
                          onClick={() => {
                            toggle('increaseAnnualSalary')
                          }}
                        >
                          <Icon name="plus"></Icon>
                          <span>Tăng thâm niên</span>
                        </Button>
                      </div>
                    </li>

                  </ul>
                </div>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>

        <Block>
          <div className="card card-bordered card-preview">
            <div className="card-inner">
              <div
                id="DataTables_Table_1_wrapper"
                className="dataTables_wrapper dt-bootstrap4 no-footer"
              >
                <div className="row justify-between g-2">
                  <div className="col-8 col-sm-6 text-start"></div>
                  <div className="col-5 col-sm-6 text-end">
                    <div className="datatable-filter">
                      <div className="d-flex justify-content-end g-2">
                        <div
                          className="dataTables_length"
                          id="DataTables_Table_1_length"
                        >
                          {/* <label>
                            <span className="d-none d-sm-inline-block">Show</span>
                            <Input type="month" />
                          </label> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="my-3">
                  <Table
                    loading={loading}
                    columns={colTable}
                    data={data}
                    notShowPagi={true}
                  ></Table>
                </div>
              </div>
            </div>
          </div>
        </Block>
        <Modal isOpen={view.changePass} toggle={() => onFormCancel()}>
          <ModalBody className="modal-body-lg text-center">
            <a href="#cancel" className="close">
              {" "}
              <Icon
                name="cross-sm"
                onClick={(ev) => {
                  ev.preventDefault();
                  onFormCancel();
                }}
              ></Icon>
            </a>
            <div className="p-2">
              <h5 className="title">Cập nhật mật khẩu</h5>
              <div className="mt-4">
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    onSubmitChangPassword();
                  }}
                >
                  <Row className="g-3">
                    <Col md="12">
                      <div className="form-group">
                        <div className="form-control-wrap">
                          <input
                            type={"password"}
                            placeholder="Vui lòng nhập mật khẩu"
                            className={`form-control`}
                            onChange={(e) => setNewPassword(e.target.value)}
                          />
                        </div>
                      </div>
                    </Col>
                    <Col size="12">
                      <Button color="primary" type="submit">
                        <Icon className="lock"></Icon>
                        <span>Cập nhật mật khẩu</span>
                      </Button>
                    </Col>
                  </Row>
                </form>
              </div>
            </div>
          </ModalBody>
        </Modal>


        <Modal isOpen={view.increaseAnnualSalary} toggle={() => onFormCancel()}>
          <ModalBody className="modal-body-lg text-center">
            <div className="nk-modal">
              <h4 className="nk-modal-title">
                Bạn có chắc muốn tăng số năm thâm niên cho toàn bộ NV?{" "}
              </h4>
              <div className="nk-modal-action mt-5 d-flex justify-content-around">
                <Button
                  color="light"
                  size="lg"
                  className="btn-mw mr-5"
                  onClick={() => onFormCancel()}
                >
                  Huỷ bỏ
                </Button>
                <Button
                  color="primary"
                  size="lg"
                  className="btn-mw"
                  onClick={(ev) => {
                    ev.preventDefault();
                    increaseAnnualSalary();
                  }}
                >
                  Xác nhận
                </Button>
              </div>
            </div>
          </ModalBody>
        </Modal>

        <Modal isOpen={view.isDelete} toggle={() => onFormCancel()}>
          <ModalBody className="modal-body-lg text-center">
            <div className="nk-modal">
              <Icon className="nk-modal-icon icon-circle icon-circle-xxl ni ni-cross bg-danger"></Icon>
              <h4 className="nk-modal-title">
                Bạn có chắc muốn xoá người dùng này không ?{" "}
              </h4>
              <div className="nk-modal-action mt-5 d-flex justify-content-around">
                <Button
                  color="light"
                  size="lg"
                  className="btn-mw mr-5"
                  onClick={() => onFormCancel()}
                >
                  Huỷ bỏ
                </Button>
                <Button
                  color="primary"
                  size="lg"
                  className="btn-mw"
                  onClick={(ev) => {
                    ev.preventDefault();
                    deleteUser(deleteId);
                  }}
                >
                  Xác nhận
                </Button>
              </div>
            </div>
          </ModalBody>
        </Modal>
      </Content>
    </React.Fragment>
  );
};

export default UserManager;
